// extracted by mini-css-extract-plugin
module.exports = {"logoBar":"createlogbutton_logoBar__3lTnS","loginButton":"createlogbutton_loginButton__-cb2d","logo":"createlogbutton_logo__2HVD9"};